var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPosts = function SvgPosts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 20,
    x: 11,
    y: 45,
    fill: "#6C9BF1",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M8 6a2 2 0 0 0-2 2v29a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm3 24a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm17 2a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H30a2 2 0 0 1-2-2zM11 10.5a1.5 1.5 0 0 0 0 3h30a1.5 1.5 0 0 0 0-3zM9.5 18a1.5 1.5 0 0 1 1.5-1.5h25.2a1.5 1.5 0 0 1 0 3H11A1.5 1.5 0 0 1 9.5 18m1.5 4.5a1.5 1.5 0 0 0 0 3h20.4a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M31 39v10a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V26a2 2 0 0 0-2-2H48v13a2 2 0 0 1-2 2z",
    clipRule: "evenodd"
  })));
};
export default SvgPosts;